import { clientIdentification } from '@gjensidige/service-client-identification';

import { BedriftstilgangWindow, MappedBedrift, WindowLinks } from '../../../types';

export const IS_BEDRIFT = clientIdentification.getApplicationId() === 'NARNET';
export const IS_PRIVAT = window.location.pathname.includes('/kunde/privat/min-side/'); // clientIdentification.getApplicationId() === 'INTERNETT';

const MAX_SHOWN_ITEMS_IN_DROPDOWN = 3;

export const userDataSessionStorageKey = 'userData';

export const cartSessionStorageKey = 'cart-items';
export const cartUrlSessionStorageKey = 'cart-url';
export const proposalsCountStorageKey = 'proposalsCount';
export const claimsWithUnreadDocumentsStorageKey = 'claimsWithUnreadDocuments';
export const consentsNotificationSessionStorageKey = 'consentsNotification';

export const bedriftstilganger = () => window.bedriftstilganger || [];

export const currentlySelectedBedrift = bedriftstilganger()?.find(
  (bedrift) => bedrift.partref === clientIdentification.getSelectedPartref()
);
export const isMegler = () => window.portaltilganger?.meglerKunde;
export const isOnlyPrivatKunde = () => !window.portaltilganger?.meglerKunde && !window.portaltilganger?.direkteKunde;
export const privateUserName = () => window.navn || 'Min bruger';
export const selectedUserName = () =>
  IS_BEDRIFT ? currentlySelectedBedrift?.navn || 'Min bedrift' : privateUserName();
export const unreadKundekontakt = () => window.unreadKundekontakt || 0;
export const unreadDokumenterPrivate = () => {
  const claimsWithUnreadDocuments = sessionStorage.getItem('claimsWithUnreadDocuments');
  if (claimsWithUnreadDocuments) {
    const claimsUnread: { count: number } = JSON.parse(claimsWithUnreadDocuments);
    if (claimsUnread?.count) {
      return claimsUnread.count;
    }
  }
  return 0;
};
export const unreadDokumenterCommercial = () => window.unreadDokumenterCommercial || 0;
export const hideInsurance = () => !!window.hideInsurance;
export const hideInsuranceCommercial = () => !!window.hideInsuranceCommercial;
export const hideKonseroversikt = () => window.bedriftstilganger && window.bedriftstilganger.length < 2;
export const divisjon = () => window.divisjon;
export const selectedCommercialPensionAgreement = () => window.selectedCommercialPensionAgreement;

export const postkasseUnread = () => {
  if (IS_PRIVAT) {
    const total = unreadDokumenterPrivate() + unreadKundekontakt();
    return total > 0 ? total : undefined;
  }
  return unreadDokumenterCommercial() > 0 ? unreadDokumenterCommercial() : undefined;
};

export const hasBedriftAndAccess = () => window.portaltilganger?.direkteKunde && !!window.bedriftstilganger?.length;

export const hideItem = (isMobile: boolean, mobileOnly?: boolean, desktopOnly?: boolean) => {
  return (!isMobile && mobileOnly) || (isMobile && desktopOnly);
};

export const mappedBedrifter: MappedBedrift = bedriftstilganger().reduce(
  (bedrifter: MappedBedrift, currentBedrift: BedriftstilgangWindow) => {
    const mappedBedrift = currentBedrift.direkte
      ? { commercial: [...bedrifter.commercial, currentBedrift] }
      : { broker: [...bedrifter.broker, currentBedrift] };

    return {
      ...bedrifter,
      ...mappedBedrift
    };
  },
  { commercial: [], broker: [] }
);

export const showByttBrukerLink = () =>
  !!mappedBedrifter?.commercial && mappedBedrifter.commercial.length > MAX_SHOWN_ITEMS_IN_DROPDOWN;

export const getUrlFromWindow = (key: keyof WindowLinks) => window.navigasjon?.[key] || '';

export const buildCommercialPensionUrl = (page: string, nci?: boolean) =>
  `/kunde/bedrift/pensjon/oversikt/${nci ? 'nci/' : ''}#/org/${currentlySelectedBedrift?.id.substring(
    2
  )}/agreement/${selectedCommercialPensionAgreement()}/${page}`;

export const buildCommercialPensionMembersUrl = () =>
  `/kunde/bedrift/pensjon/medlemmer/#/org/${currentlySelectedBedrift?.id.substring(
    2
  )}/agreement/${selectedCommercialPensionAgreement()}/overview`;

export const existsAtSessionStorage = (key: string): boolean => {
  if (window && window.sessionStorage) {
    return !!sessionStorage.getItem(key);
  }

  return false;
};

export const getSessionStorageJSON = <T extends object>(key: string): T | null => {
  try {
    const stored = getSessionStorageOrDefault(key);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.log('Error getting from storage', error);
  }
  return null;
};

export const getSessionStorageOrDefault = (key: string) => {
  if (window && window.sessionStorage) {
    return sessionStorage.getItem(key);
  }
  return null;
};

export const clearCache = () => {
  sessionStorage.removeItem(userDataSessionStorageKey);
  sessionStorage.removeItem(cartSessionStorageKey);
  sessionStorage.removeItem(cartUrlSessionStorageKey);
  sessionStorage.removeItem(consentsNotificationSessionStorageKey);
};
